import { createAction, props } from '@ngrx/store';

import { TransformerInterface } from '@gfe/core/models/entities/entity-visualization-interface';

import { DataSpaceModel } from '../../models/dataspace/data-space.model';
import { EntityMetadata } from '../../models/entity/entity-metadata.model';
import { TransformerInfo } from '../../models/transformers.model';

export const fetchDataspace = createAction(
  '[Dataspace] Fetch dataspace metadata',
  props<{
    id: number;
  }>()
);

export const refreshDataspace = createAction(
  '[Dataspace] Refresh current dataspace metadata'
);

export const switchToDataspace = createAction(
  '[Dataspace] Switch to dataspace',
  props<{
    dataspace: DataSpaceModel;
    availableEntities: EntityMetadata[];
    availableTransformers: TransformerInterface[];
    transformersInfo: TransformerInfo[];
  }>()
);

export const fetchDataspaceFailure = createAction(
  '[Dataspace] Fetch dataspace failure',
  props<{
    id: number;
    error: unknown;
  }>()
);
